<template>
    <div class="d-flex justify-content-center mt-3">
      <nav class="pagination-custom">
        <div class="page-item disabled">
          <img
            class="control"
            :class="{ 'rotate-180': $i18n.locale === 'en' }"
            src="@/assets/images/home/advocacypillar/right-arrow.png"
            alt="Right Arrow" 
          />
        </div>
  
        <span
          class="page-item"
        >1</span>
        <span
          class="page-item"
        >2</span>
        <span
          class="page-item"
        >3</span>
        <div class="page-item active">
          <img
            class="control"
            :class="{ 'rotate-180': $i18n.locale === 'en' }"
            src="@/assets/images/home/advocacypillar/left-arrow.png"
            alt="Left Arrow"
          />
        </div>
      </nav>
    </div>
  </template>
  
  <script>
  
  export default {
  

  };
  </script>
  
  <style scoped>
  .pagination-custom {
    display: flex;
    align-items: center;
  }
  
  .page-item {
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid #c49a3a;
    color: #c49a3a;
    margin-inline-end: 10px;
  }
  
  .page-item.active , .page-item:hover{
    background-color: #c49a3a;
    /* Gold */
    border: none;
    color: white;
  }
  
  .page-item.disabled {
    background-color: #f8f5eb;
    /* Light beige */
    border: none;
    color: #d1c4a8;
  }
  
  
  .control {
    height: 12px;
  }
  
  .rotate-180 {
    transform: rotate(180deg);
  }
  </style>
  